export const reviews: Array<[string, string, string, string]> = [
  [
    'AP',
    'Andrea P.',
    'Docente de Energías Renovables — Lima, Perú',
    'Mis alumnos por fin entienden la diferencia entre energía solar fotovoltaica y sistemas eólicos. Antes yo misma perdía tiempo buscando cómo explicar correctamente cómo funcionan. Ahora entro al aula con todo listo.',
  ],
  [
    'CM',
    'Carlos M.',
    'Profesor de Energías Renovables — Buenos Aires, Argentina',
    'Nunca más llegué a una clase sin saber cómo explicar el dimensionamiento de una instalación solar o cómo se calcula la autonomía de un sistema. El material hace el trabajo pesado por mí.',
  ],
  [
    'SL',
    'Sofía L.',
    'Docente de Energías Renovables — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Los proyectos integradores están organizados paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'VT',
    'Valeria T.',
    'Docente de Energías Renovables | Lima, Perú',
    'El material sobre sistemas solares y dimensionamiento le cambió la cara a mis alumnos. Por fin entienden cómo se calcula realmente una instalación. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'CR',
    'Carlos R.',
    'Profesor de Energías Renovables | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto.',
  ],
  [
    'DG',
    'Daniel G.',
    'Docente de Energías Renovables | Caracas, Venezuela',
    'Los 100 problemas resueltos transformaron a los alumnos que no entendían cálculos de potencia y autonomía. Ahora ven paso a paso cómo se resuelve y lo aplican solos. Eso no lo encontré en ningún otro material.',
  ],
  [
    'AM',
    'Ana M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'La guía visual de componentes me devolvió el tiempo de clase. Antes perdía veinte minutos explicando cómo funciona un inversor. Ahora proyecto la guía y mis alumnos entienden al instante.',
  ],
  [
    'SR',
    'Sebastián R.',
    'Profesor de Energías Renovables | Quito, Ecuador',
    'Los 50 proyectos integradores fueron una revelación. Mis alumnos finalmente entienden para qué es todo esto. Hacen proyectos sobre sistemas solares en sus propias comunidades. Eso cambió completamente su relación con las energías renovables.',
  ],
];
